// extracted by css-extract-rspack-plugin
export default {"SidebarContentMain":"EoSSt","FooterButton":"Cxe5l","SidebarContentRoot":"_3XgT","SidebarContentHeader":"U8kKS"};